export { default } from './diagonal-line.component';
